var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogoW = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 50 50"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m29.191 36.631 8.755-20.56h-4.228l-4.683 11-5.014-11.772-5.01 11.774-4.683-11H10.1l8.75 20.561 5.171-12.15z",
  "data-name": "\\uD328\\uC2A4 159"
})), /*#__PURE__*/React.createElement("path", {
  d: "M321.72 141.677h4.767l-2.384-5.6z",
  "data-name": "\\uD328\\uC2A4 159",
  style: {
    fill: "#fa5500"
  },
  transform: "translate(-286.716 -106.095)"
}));
export default SvgLogoW;